import {
  ClientPropertyConfig,
  HazardTechnicalReports,
  mapPropertyInformationResponse,
  PropertyInformation,
  PropertyInformationResponse,
  PropertySuggestion,
} from '@app/components/Property/types'
import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'

export const fetchClientPropertyConfig = async (): Promise<ClientPropertyConfig> => {
  const { data } = await apiClient.get<ClientPropertyConfig>(Endpoint.getClientPropertyConfig)
  return data
}

export const fetchPropertyAddressSuggestions = async (
  assetType: string,
  searchQuery: string,
  signal?: AbortSignal,
): Promise<PropertySuggestion[]> => {
  const { data } = await apiClient.get<PropertySuggestion[]>(`/search/asset/${assetType}`, {
    params: { search_query: searchQuery },
    signal,
  })
  return data
}

export const fetchHazardTechnicalReports = async (
  scenarioIds: string[],
  signal?: AbortSignal,
): Promise<HazardTechnicalReports> => {
  const { data } = await apiClient.get<HazardTechnicalReports>(
    `/hazard/technical_reports/${scenarioIds.join(',')}`,
    { signal },
  )
  return data
}

export const fetchPropertyInformation = async (
  assetType?: string,
  assetId?: string,
): Promise<PropertyInformation> => {
  const { data } = await apiClient.get<PropertyInformationResponse>(
    `/asset/identifying_information/${assetType}/${assetId}`,
  )
  return mapPropertyInformationResponse(data)
}
